import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { Hub } from '@qwyk/models';

import { MagayaNetworkConfigurationEntity } from './../../+state/magaya-network-configuration.models';

@Component({
    selector: 'qwyk-magaya-network-detail',
    templateUrl: './magaya-network-detail.component.html',
    styleUrls: ['./magaya-network-detail.component.scss'],
})
export class MagayaNetworkDetailComponent {
    @Input()
    public organization: Hub.Organization;
    @Input()
    public magayaNetworkConfiguration: MagayaNetworkConfigurationEntity;
    @Input()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public error: any;
    @Input()
    public loading: boolean;
    @Output()
    public testConnection: EventEmitter<Hub.Organization> = new EventEmitter<Hub.Organization>();

    @Output()
    public edit: EventEmitter<void> = new EventEmitter<void>();

    public get iconAnimation(): 'pulse' | undefined {
        return this.loading ? 'pulse' : undefined;
    }

    public get connectionStatusIcon(): string {
        if (this.loading) {
            return 'spinner';
        }
        switch (this.magayaNetworkConfiguration.last_connection_successful) {
            case true:
                return 'check-circle';
            case false:
                return 'exclamation-triangle';
            default:
                return 'question';
        }
    }

    public get connectionStatusStyle(): string {
        switch (this.magayaNetworkConfiguration.last_connection_successful) {
            case true:
                return 'text-success';
            case false:
                return 'text-danger';
            default:
                return 'text-warning';
        }
    }

    public get connectionStatusText(): string {
        switch (this.magayaNetworkConfiguration.last_connection_successful) {
            case true:
                return this.translate.instant(
                    'hub.console.organizations.successfully-connected'
                );
            case false:
                return this.translate.instant(
                    'hub.console.organizations.failed-to-connect'
                );
            default:
                return this.translate.instant('common.unknown');
        }
    }

    constructor(private translate: TranslateService) {}

    public onTestConnection(): void {
        this.testConnection.emit(this.organization);
    }
}
